import React from 'react';
import { compose } from 'redux';

import { withContent } from 'components/Content';
import Hero from 'components/Hero';
import withLanding from 'containers/Landing/withLanding';
import { pages as PAGES } from 'containers/Landing/constants';
import OurServices from 'components/OurServices';
import Gulch from 'components/Gulch';
import Divider from 'components/Ui/Divider';
import Backgrounder from 'components/Backgrounder';
import Dispensers from 'components/Dispensers';
import Clientele from '../Clientele';

import styles from './comm.scss';

const CONTENT_KEYS = {
  hero: 'Hero',
  services: 'Our Services',
  dispensers: 'Dispensers',
  clientele: 'Clientele',
};

const Commercial = ({ content }) => (
  <div className={styles.comm}>
    <Hero content={content.hero} />
    <OurServices className={styles.ourServices} content={content.services} />
    <Gulch />
    <Clientele content={content.clientele} />
    <Divider />
    <Backgrounder>
      <Dispensers content={content.dispensers} />
    </Backgrounder>
  </div>
);

export default compose(
  withLanding(PAGES.commercialServices),
  withContent(CONTENT_KEYS),
)(Commercial);
